import { render, staticRenderFns } from "./HorarioClases.vue?vue&type=template&id=5a18c18a&"
import script from "./HorarioClases.vue?vue&type=script&lang=js&"
export * from "./HorarioClases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports